/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  HStack,
  Heading,
  Image,
  Link,
  Spinner,
  Stack,
  Text,
  VStack,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { SearchContext } from '../context';
import { SearchJobsListing } from '../jobs';
import { SearchCompanyPagesListing } from '../pages/listing';
import { SearchPeopleListing } from '../people/listing';
import { SearchPostsListing } from '../posts/listing';
import { SearchTeamsListing } from '../teams/listing';
import { SearchEventsListing } from '../events/listing';
import { SearchArticlesListing } from '../articles/listing';
import {
  JobsListingContext,
  useJobsListingContext,
} from 'v4/snippets/jobs/context';
import {
  CompanyPagesContext,
  useCompanyPagesContext,
} from 'v4/snippets/company/context';
import { TeamsContext, useTeamsContext } from 'v4/snippets/teams/context';
import { SearchNewJobListing } from '../jobs/listing';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const AllSearchListing = forwardRef(({ ...props }, ref) => {
  const {
    search,
    allSearch,
    setActiveTab,
    refetchAllSearch,
    allSearchIsFetching,
    activeTab,
    query,
  } = useContext(SearchContext);
  const [showAllPeople, setShowAllPeople] = useState(false);
  const [showAllEvents, setShowAllEvents] = useState(false);
  const [showAllArticles, setShowAllArticles] = useState(false);
  const [showAllTeams, setShowAllTeams] = useState(false);
  const [showAllJobs, setShowAllJobs] = useState(false);
  const [showAllPages, setShowAllPages] = useState(false);
  const [showAllPosts, setShowAllPosts] = useState(false);
  const { t } = useTranslator();
  useEffect(() => {
    if (activeTab === 'all') {
      refetchAllSearch?.();
    }
  }, [search, activeTab]);

  const jobsCtx = useJobsListingContext({});
  const pagesCtx = useCompanyPagesContext({});
  const teamsCtx = useTeamsContext({});

  const locationSearch =
    typeof window === 'undefined' ? '' : window.location.search;

    
  return (
    <>
      <JobsListingContext.Provider value={jobsCtx}>
        <CompanyPagesContext.Provider value={pagesCtx}>
          <TeamsContext.Provider value={teamsCtx}>
            {allSearchIsFetching ? (
              <HStack justifyContent="center">
                <Spinner />
              </HStack>
            ) : (
              ''
            )}
            {allSearch?.count?.people ? (
              <Stack>
                <Heading
                  as="h1"
                  pl={2}
                  fontSize="20px"
                  color="brandPrimary.500"
                  fontWeight="400"
                >
                  {t('searchPage.people') || "People"}
                </Heading>
                <Text pl={2} fontSize="xs">
                  {t('pages.about') || "About"} {allSearch?.count?.people} {t('pageJobs.results') || "results"}
                </Text>
                <SearchPeopleListing
                  count={allSearch?.count?.people}
                  listing={
                    showAllPeople
                      ? allSearch?.results?.people
                      : allSearch?.results?.people.slice(0, 5)
                  }
                  isMainList={true}
                />
                {allSearch?.results?.people.length >= 5 && (
                  <HStack>
                    {/* <HStack justifyContent="center" my={2} ml={[2, null]}>
                      <Button
                        onClick={() => setShowAllPeople(!showAllPeople)}
                        variant="secondary"
                      >
                        {showAllPeople
                          ? 'Show Less'
                          : `Show More (${allSearch?.results?.people.length})`}
                      </Button>
                    </HStack> */}
                    <HStack justifyContent="center" my={2} ml={[2, null]}>
                      <Button
                        borderRadius="30px"
                        as={Link}
                        href={'/g/people' + locationSearch}
                        variant="secondary"
                      >
                        {t('myCalendar.viewAll') || "View All"}
                      </Button>
                    </HStack>
                  </HStack>
                )}
              </Stack>
            ) : (
              ''
            )}
            {allSearch?.count?.jobs ? (
              <Stack mt={[null, 10]} mb={[10, null]}>
                <Heading
                  pl={2}
                  fontSize="20px"
                  color="brandPrimary.500"
                  fontWeight="400"
                >
                  {t('pages.jobs') || "Jobs"}
                </Heading>
                <Text pl={2} fontSize="xs">
                  {t('pages.about') || "About"} {allSearch?.count?.jobs} {t('pageJobs.results') || "results"}
                </Text>
                <SearchNewJobListing
                  count={allSearch?.count?.jobs}
                  listing={
                    showAllJobs
                      ? allSearch?.results?.jobs
                      : allSearch?.results?.jobs.slice(0, 5)
                  }
                  isMainList={true}
                />
                {allSearch?.results?.jobs.length >= 5 && (
                  <HStack>
                    {/* <HStack justifyContent="center" my={2} ml={[2, null]}>
                      <Button
                        onClick={() => setShowAllJobs(!showAllJobs)}
                        variant="secondary"
                      >
                        {showAllJobs
                          ? 'Show Less'
                          : `Show More (${allSearch?.results?.jobs.length})`}
                      </Button>
                    </HStack> */}
                    <HStack justifyContent="center" my={2} ml={[2, null]}>
                      <Button
                        borderRadius="30px"
                        as={Link}
                        href={'/g/jobs' + locationSearch}
                        // href={`/jobs/search?title=${query?.query}&query=${query?.query}`}
                        variant="secondary"
                      >
                        {t('myCalendar.viewAll') || "View All"}
                      </Button>
                    </HStack>
                  </HStack>
                )}
              </Stack>
            ) : (
              ''
            )}
            {allSearch?.count?.pages ? (
              <Stack mt={[null, 10]} mb={[10, null]}>
                <Heading
                  pl={2}
                  fontSize="20px"
                  color="brandPrimary.500"
                  fontWeight="400"
                >
                  {t('profileNetwork.pages') || "Pages"}
                </Heading>
                <Text pl={2} fontSize="xs">
                  {t('pages.about') || "About"} {allSearch?.count?.pages} {t('pageJobs.results') || "results"}
                </Text>
                <SearchCompanyPagesListing
                  count={allSearch?.count?.pages}
                  listing={
                    showAllPages
                      ? allSearch?.results?.pages
                      : allSearch?.results?.pages.slice(0, 5)
                  }
                  isMainList={true}
                />
                {allSearch?.results?.pages.length >= 5 && (
                  <HStack>
                    {/* <HStack justifyContent="center" my={2} ml={[2, null]}>
                      <Button
                        onClick={() => setShowAllPages(!showAllPages)}
                        variant="secondary"
                      >
                        {showAllPages
                          ? 'Show Less'
                          : `Show More (${allSearch?.results?.pages.length})`}
                      </Button>
                    </HStack> */}
                    <HStack justifyContent="center" my={2} ml={[2, null]}>
                      <Button
                        borderRadius="30px"
                        as={Link}
                        href={'/g/pages' + locationSearch}
                        variant="secondary"
                      >
                        {t('myCalendar.viewAll') || "View All"}
                      </Button>
                    </HStack>
                  </HStack>
                )}
              </Stack>
            ) : (
              ''
            )}
            {allSearch?.count?.post ? (
              <Stack mt={[null, 10]} mb={[10, null]}>
                <Heading
                  pl={2}
                  fontSize="20px"
                  color="brandPrimary.500"
                  fontWeight="400"
                >
                  {t('createPage.posts') || "Posts"}
                </Heading>
                <Text pl={2} fontSize="xs">
                  {t('pages.about') || "About"} {allSearch?.count?.post} {t('pageJobs.results') || "results"}
                </Text>
                <SearchPostsListing
                  count={allSearch?.count?.post}
                  listing={
                    showAllPosts
                      ? allSearch?.results?.post
                      : allSearch?.results?.post.slice(0, 5)
                  }
                  isMainList={true}
                />
                {allSearch?.results?.post.length >= 5 && (
                  <HStack>
                    {/* <HStack justifyContent="center" my={2} ml={[2, null]}>
                      <Button
                        onClick={() => setShowAllPosts(!showAllPosts)}
                        variant="secondary"
                      >
                        {showAllPosts
                          ? 'Show Less'
                          : `Show More (${allSearch?.results?.post.length})`}
                      </Button>
                    </HStack> */}
                    <HStack justifyContent="center" my={2} ml={[2, null]}>
                      <Button
                        borderRadius="30px"
                        as={Link}
                        href={'/' + locationSearch}
                        variant="secondary"
                      >
                        {t('myCalendar.viewAll') || "View All"}
                      </Button>
                    </HStack>
                  </HStack>
                )}
              </Stack>
            ) : (
              ''
            )}
            {allSearch?.count?.team ? (
              <Stack mt={[null, 10]} mb={[10, null]}>
                <Heading
                  pl={2}
                  fontSize="20px"
                  color="brandPrimary.500"
                  fontWeight="400"
                >
                  {t('teams.teams') || "Teams"}
                </Heading>
                <Text pl={2} fontSize="xs">
                  {`${t('pages.about') || "About"} ${allSearch?.results?.team.length} ${t('pageJobs.results') || "results"}`}
                </Text>
                <SearchTeamsListing
                  count={allSearch?.count?.team}
                  listing={
                    showAllTeams
                      ? allSearch?.results?.team
                      : allSearch?.results?.team.slice(0, 5)
                  }
                  isMainList={true}
                />
                {allSearch?.results?.team.length >= 5 && (
                  <HStack>
                    <HStack justifyContent="center" my={2} ml={[2, null]}>
                      {/* <Button
                        onClick={() => setShowAllTeams(!showAllTeams)}
                        variant="secondary"
                      >
                        {showAllTeams
                          ? 'Show Less'
                          : `Show More (${allSearch?.results?.team.length})`}
                      </Button> */}
                    </HStack>
                    <HStack justifyContent="center" my={2} ml={[2, null]}>
                      <Button
                        borderRadius="30px"
                        as={Link}
                        href={'/g/teams' + locationSearch}
                        variant="secondary"
                      >
                        {t('myCalendar.viewAll') || "View All"}
                      </Button>
                    </HStack>
                  </HStack>
                )}
              </Stack>
            ) : (
              ''
            )}
            {allSearch?.count?.events ? (
              <Stack mt={[null, 10]} mb={[10, null]} >
                <Heading
                  pl={2}
                  fontSize="20px"
                  color="brandPrimary.500"
                  fontWeight="400"
                >
                  {t('navigation.events') || "Events"}
                </Heading>
                <Text pl={2} fontSize="xs">
                  {t('pages.about') || "About"} {allSearch?.count?.events} {t('pageJobs.results') || "results"}
                </Text>
                <SearchEventsListing
                  count={allSearch?.count?.events}
                  listing={
                    showAllEvents
                      ? allSearch?.results?.events
                      : allSearch?.results?.events.slice(0, 5)
                  }
                  isMainList={true}
                  fromPublic={true}
                />
                {allSearch?.results?.events.length >= 5 && (
                  <HStack>
                    {/* <HStack justifyContent="center" my={2} ml={[2, null]}>
                      <Button
                        onClick={() => setShowAllEvents(!showAllEvents)}
                        variant="secondary"
                      >
                        {showAllEvents
                          ? 'Show Less'
                          : `Show More (${allSearch?.results?.events.length})`}
                      </Button>
                    </HStack> */}
                    <HStack justifyContent="center" my={2} ml={[2, null]}>
                      <Button
                        borderRadius="30px"
                        as={Link}
                        href={'/g/events' + locationSearch}
                        variant="secondary"
                      >
                        {t('myCalendar.viewAll') || "View All"}
                      </Button>
                    </HStack>
                  </HStack>
                )}
              </Stack>
            ) : (
              ''
            )}
            {allSearch?.count?.articles ? (
              <Stack mt={[null, 10]} mb={[10, null]}>
                <Heading
                  pl={2}
                  fontSize="20px"
                  color="brandPrimary.500"
                  fontWeight="400"
                >
                  {t('navigation.articles') || "Articles"}
                </Heading>
                <Text pl={2} fontSize="xs">
                  {t('pages.about') || "About"} {allSearch?.count?.articles} {t('pageJobs.results') || "results"}
                </Text>
                <SearchArticlesListing
                  count={allSearch?.count?.articles}
                  listing={
                    showAllArticles
                      ? allSearch?.results?.articles
                      : allSearch?.results?.articles.slice(0, 5)
                  }
                  isMainList={true}
                  fromPublic={true}
                  fromIndex={true}
                />
                {allSearch?.results?.articles.length >= 5 && (
                  <HStack>
                    {/* <HStack justifyContent="center" my={2} ml={[2, null]}>
                      <Button
                        onClick={() => setShowAllArticles(!showAllArticles)}
                        variant="secondary"
                      >
                        {showAllArticles
                          ? 'Show Less'
                          : `Show More (${allSearch?.results?.articles.length})`}
                      </Button>
                    </HStack> */}
                    <HStack justifyContent="center" my={2} ml={[2, null]}>
                      <Button
                        borderRadius="30px"
                        as={Link}
                        href={'/g/articles' + locationSearch}
                        variant="secondary"
                      >
                        {t('myCalendar.viewAll') || "View All"}
                      </Button>
                    </HStack>
                  </HStack>
                )}
              </Stack>
            ) : (
              ''
            )}

            {!allSearch?.count?.articles &&
            !allSearch?.count?.events &&
            !allSearch?.count?.team &&
            !allSearch?.count?.post &&
            !allSearch?.count?.pages &&
            !allSearch?.count?.jobs &&
            !allSearch?.count?.people &&
            !allSearchIsFetching ? (
              <VStack
                justifyContent="center"
                alignItems="center"
                h="calc(80vh - 64px)"
              >
                <Image
                  src="/images/defaultSearchImage.svg"
                  alt="default Image"
                  width={['80%', '400px']}
                />
                <Text fontSize="18px" color="#AFAFAF" fontWeight="500">
                  {t('searchPage.noResultsFound') || "No results found"}
                </Text>
                <Text fontSize="14px" color="#AFAFAF" fontWeight="500">
                  {t('searchPage.tryRephrasing') || "Try shortening or rephrasing your search."}
                </Text>
              </VStack>
            ) : (
              <></>
            )}
          </TeamsContext.Provider>
        </CompanyPagesContext.Provider>
      </JobsListingContext.Provider>
    </>
  );
});
